import { Views } from './views.js';
import icons from '../../img/icons.svg';
import fracty from 'fracty';

class RecipeView extends Views {
  _parentElement = document.querySelector(`.recipe`);
  _errorMessage = `No information found about the selected recipe!`;

  getHash() {
    return window.location.hash.slice(1);
  }

  attachHandlerControlRecipeView(handler) {
    [`hashchange`, `load`].forEach(event =>
      window.addEventListener(event, handler)
    );
  }

  attachHandlerControlServings(handler) {
    this._parentElement.addEventListener(`click`, function (e) {
      const btn = e.target.closest(`.btn--update-servings`);
      if (!btn) return;
      const newServings = +btn.dataset.updateTo;
      if (!newServings) return;
      handler(newServings);
    });
  }

  attachHandlerControlBookmarksView(handler) {
    this._parentElement.addEventListener(`click`, function (e) {
      const btn = e.target.closest(`.btn--round`);
      if (!btn) return;
      handler(btn);
    });
  }

  _generateMarkup() {
    return `
    <figure class="recipe__fig">
    <img src="${this._data.recipe.image}" alt="${
      this._data.recipe.title
    }" class="recipe__img" />
    <h1 class="recipe__title">
      <span>${this._data.recipe.title}</span>
    </h1>
  </figure>

  <div class="recipe__details">
    <div class="recipe__info">
      <svg class="recipe__info-icon">
        <use href="${icons}#icon-clock"></use>
      </svg>
      <span class="recipe__info-data recipe__info-data--minutes">${
        this._data.recipe.cookingTime
      }</span>
      <span class="recipe__info-text">minutes</span>
    </div>
    <div class="recipe__info">
      <svg class="recipe__info-icon">
        <use href="${icons}#icon-users"></use>
      </svg>
      <span class="recipe__info-data recipe__info-data--people">${
        this._data.recipe.servings
      }</span>
      <span class="recipe__info-text">servings</span>

      <div class="recipe__info-buttons">
        <button class="btn--tiny btn--update-servings" data-update-to = "${
          this._data.recipe.servings - 1
        }">
          <svg>
            <use href="${icons}#icon-minus-circle"></use>
          </svg>
        </button>
        <button class="btn--tiny btn--update-servings" data-update-to = "${
          this._data.recipe.servings + 1
        }">
          <svg>
            <use href="${icons}#icon-plus-circle"></use>
          </svg>
        </button>
      </div>
    </div>

    <div class="recipe__user-generated ${
      this._data.recipe.key ? `` : `hidden`
    }">
      <svg>
        <use href="${icons}#icon-user"></use>
      </svg>
    </div>
    <button class="btn--round">
      <svg class="${
        this._data.bookmarks.some(recipe => recipe.id === this._data.recipe.id)
          ? `bookmarked`
          : ``
      }">
        <use href="${icons}#icon-bookmark${
      this._data.bookmarks.some(recipe => recipe.id === this._data.recipe.id)
        ? `-fill`
        : ``
    }"></use>
      </svg>
    </button>
  </div>

  <div class="recipe__ingredients">
    <h2 class="heading--2">Recipe ingredients</h2>
    <ul class="recipe__ingredient-list">
    ${this._data.recipe.ingredients
      .map(ing => {
        return `
            <li class="recipe__ingredient">
            <svg class="recipe__icon">
              <use href="${icons}#icon-check"></use>
            </svg>
            <div class="recipe__quantity">${
              ing.quantity ? fracty(ing.quantity) : ``
            }</div>
            <div class="recipe__description">
              <span class="recipe__unit">${ing.unit}</span>
              ${ing.description}
            </div>
          </li>
            `;
      })
      .join(``)}
    </ul>
  </div>

  <div class="recipe__directions">
    <h2 class="heading--2">How to cook it</h2>
    <p class="recipe__directions-text">
      This recipe was carefully designed and tested by
      <span class="recipe__publisher">${
        this._data.recipe.publisher
      }</span>. Please check out
      directions at their website.
    </p>
    <a
      class="btn--small recipe__btn"
      href="${this._data.recipe.sourceUrl}"
      target="_blank"
    >
      <span>Directions</span>
      <svg class="search__icon">
        <use href="${icons}#icon-arrow-right"></use>
      </svg>
    </a>
  </div>
    `;
  }
}

export default new RecipeView();
